module.exports = __webpack_public_path__ + "img/arrow-up-down-white.df995787.png";